import React, {useState, Fragment, useContext, createContext} from "react";
import {Fade, Modal} from "@mui/material";
import {Svg} from "assets";

export const ModalContext = createContext(null);

export const ModalProvider = ({children}) => {
    const [params, setParams] = useState({});
    const [modalInfo, setModalInfo] = useState({});

    return (
        <Fragment>
            <ModalContext.Provider
                value={{
                    params,
                    setParams,
                    modalInfo,
                    setModalInfo,
                }}
            >
                {children}
            </ModalContext.Provider>
        </Fragment>
    );
};

export const useModal = () => {
    const {params, setParams, modalInfo, setModalInfo} =
        useContext(ModalContext);

    return {
        openModal: (params = {}, modalInfo) => {
            setParams(params);
            setModalInfo(modalInfo);
        },
        close: () => {
            setParams({});
            setModalInfo({});
        },
        params,
        modalInfo,
    };
};

export const Modals = () => {
    const {params, close, modalInfo} = useModal();
    const renderOpen = Object.keys(params).length !== 0;

    return (
        renderOpen && (
            <Modal
                style={{zIndex: "1405"}}
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={renderOpen}
                onClose={() => {
                    if (!modalInfo?.dontClose){
                        close()
                    }
                }}
                closeAfterTransition
                hideBackdrop={false}
            >
                <Fade in={renderOpen}>
                    <div
                        style={
                            {
                                padding: modalInfo?.padding === "noPaddings" ? 0 : '',
                                outline: modalInfo?.padding === "noPaddings" ? 'none' : 'none',
                                maxWidth: modalInfo?.maxWidth ? modalInfo?.maxWidth : 'inherit',
                                ...modalInfo?.styles
                            }
                        }
                        className={`modal-wrapper ${
                            modalInfo?.className ? modalInfo?.className : ""
                        }`}
                    >
                        {!modalInfo?.noShowCloseBtn && (
                            <div className="modal-header-style">
                                <button
                                    type="button"
                                    className="close-modal-btn"
                                    onClick={() => close()}
                                >
                                    <Svg.CloseSvg/>
                                </button>
                            </div>
                        )}
                        {params}
                    </div>
                </Fade>
            </Modal>
        )
    );
};
